/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface IFieldSectionScope extends IBaseFieldSectionScope {
        model: FieldSectionModel;
    }

    export class FieldSection implements IDirective {
        public link($scope: IFieldSectionScope,
            element: JQuery,
            attrs: ng.IAttributes) {
        }

        public templateUrl = './app/views/directives/inputForm/fieldSection.html';
        public restrict: string = 'E';
        public controller = ['$scope', 'ModalService', 'formSectionService', 'formService', 'deleteService', FieldSectionController];
        public controllerAs = 'controller';
        public scope: any = {
            isConfigureMode: "=",
            isEditMode: "=",
            showSlider: "=",
            field: "=",
            formSection: "=",
            formData: "=",
            isReadOnly: "=",
            fieldBlurred: "=",
            processConfigurationId: "=",
            processConfiguration: "=",
            formDataId: "=",
            formId: "=",
            processId: "=",
            process: "=",
            parentFormId: "=",
            step: "=",
            form: "="
        };
    }

    export class FieldSectionModel extends FieldBaseModel {

        constructor($scope: IFieldSectionScope, modalService: any, formSectionService: warsApp.services.FormSectionService, formService: warsApp.services.FormService,
            deleteService: services.DeleteService) {
            super($scope, modalService, formSectionService, formService, deleteService);
        }

        public join(field, group) {
            field.isSplitRow = false;
            this.formSectionService.splitFields(group);
            this.formService.saveAllChanges();
        }

        public split(field, group) {
            field.isSplitRow = true;
            this.formSectionService.splitFields(group);
            this.formService.saveAllChanges();
        }
    }

    export class FieldSectionController implements IController {
        constructor(
            $scope: IFieldSectionScope,
            private modalService: any,
            private formSectionService: services.FormSectionService,
            private formService: services.FormService,
            private deleteService: services.DeleteService)
        {
            $scope.model = new FieldSectionModel($scope, modalService, formSectionService, formService, deleteService);
        }
    }
}

warsApp.registerDirective('FieldSection', []);